export default __webpack_public_path__ + "static/media/icon-button-arrow-right-red.a2be7d5e.svg";